<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Navigation" pageTitle="Navigation" />
            <NavigationContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import NavigationContent from '../Navigation/NavigationContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'NavigationPage',
    components: {
        MainHeader,
        PageTitle,
        NavigationContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>